import { useEffect, useState } from "react";

import { TextInput } from "@primer/react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { ALL_POSTS_LABEL, LABEL_COLOUR_MAP, getLabelColor } from "../../constants";
import Search from "../Images/search";
import styles from "./index.module.css";
import { useTheme } from "../../themeContext";

const FilterContainer = ({
  searchText,
  setSearchText,
  selectedLabels,
  setSelectedLabels,
}) => {
  const [slugUrl, setSlugUrl] = useState("");

  const params = useParams();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isDark } = useTheme();

  const slugParam = params.slug;

  useEffect(() => {
    if (slugParam) {
      setSlugUrl(slugParam);
    }
  }, [slugParam]);

  const handleSearch = (inputText) => {
    setSearchText(inputText);
    if (slugUrl) {
      setSlugUrl("");
      navigate({ pathname: "/", search: searchParams.toString() });
    }
  };

  const handleTagClick = (label) => {
    // on selecting any other label apart from the default selected on page load, remove the slug from url
    // and land on home page
    if (slugUrl) {
      setSlugUrl("");
      navigate({ pathname: "/", search: searchParams.toString() });
    }

    setSelectedLabels((prevLabels) => {
      let newLabels = [...prevLabels];

      if (label === ALL_POSTS_LABEL) {
        // If "All Posts" is clicked or no labels are selected, reset to "All Posts"
        return [ALL_POSTS_LABEL];
      }

      // If "All Posts" is selected and another label is clicked, remove "All Posts"
      if (newLabels.includes(ALL_POSTS_LABEL)) {
        newLabels = newLabels.filter(
          (selectedLabel) => selectedLabel !== ALL_POSTS_LABEL
        );
      }
      // Toggle the label in the selectedLabels array
      if (newLabels.includes(label)) {
        newLabels = newLabels.filter(
          (selectedLabel) => selectedLabel !== label
        );
      } else {
        newLabels = [...newLabels, label];
      }

      // If no labels left, default back to All Posts
      if (newLabels.length === 0) {
        return [ALL_POSTS_LABEL];
      }

      return newLabels;
    });
  };

  return (
    <aside className={styles.filterContainer}>
      <div className={styles.textInputDiv}>
        <TextInput
          leadingVisual={Search}
          onChange={(e) => {
            handleSearch(e.target.value);
          }}
          value={searchText}
          placeholder="Search changelogs"
          style={{ fontSize: "14px" }}
        />
      </div>
      <ul className={styles.noListStyle}>
        <li
          className={`${
            selectedLabels.includes(ALL_POSTS_LABEL)
              ? `${styles.activeTag}`
              : ""
          } ${styles.labelTagLi}`}
          key={ALL_POSTS_LABEL}
          onClick={() => {
            handleTagClick(ALL_POSTS_LABEL);
          }}
        >
          <span className={styles.tagListContainer}>
            <span className={styles.tagLabel}>All Posts</span>
          </span>
        </li>

        {Object.keys(LABEL_COLOUR_MAP).map((label) => {
          const trimmedLabel = label.trim();

          if (trimmedLabel.toLowerCase() === ALL_POSTS_LABEL.toLowerCase()) {
            return null;
          }

          const tagColor = getLabelColor(trimmedLabel, isDark);
          return (
            <li
              className={`${
                selectedLabels.includes(trimmedLabel)
                  ? `${styles.activeTag}`
                  : ""
              } ${styles.labelTagLi}`}
              key={trimmedLabel}
              onClick={() => handleTagClick(trimmedLabel)}
            >
              <span className={styles.tagListContainer}>
                <span
                  className={styles.tagLabelPrefix}
                  style={{ background: tagColor }}
                />
                <span className={styles.tagLabel}>{trimmedLabel}</span>
              </span>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default FilterContainer;
